import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { getShowDetails, imdbShowDetailsDto } from "../../api";

export enum Status {
    INACTIVE = "INACTIVE",
    LOADING = "LOADING",
    SUCCESSFUL = "SUCCESSFUL",
    ERROR = "ERROR",
}

export interface ShowDetailsState {
    details: imdbShowDetailsDto;
    status?: Status;
}

const initialState: ShowDetailsState = {
    details: {data: null},
    status: Status.INACTIVE,
}

export const showDetailsSlice = createSlice({
    name: 'showDetails',
    initialState,
    reducers: {
        setShowDetailsState: (state: ShowDetailsState, action: PayloadAction<ShowDetailsState>) => {
            state.details = action.payload.details;
        },
        resetShowDetailsState: (state: ShowDetailsState) => {
            state.details = initialState.details;
            state.status = initialState.status;
        },
        showDetailsStateStart: (state: ShowDetailsState) => {
            state.status = Status.LOADING;
        },
        showDetailsStateEnd: (state: ShowDetailsState, action: PayloadAction<Status>) => {
            state.status = action.payload;
        }
    }
});

export const {
    setShowDetailsState,
    resetShowDetailsState,
    showDetailsStateStart,
    showDetailsStateEnd,
} = showDetailsSlice.actions;

export const loadShowDetails = (id: string) => async (dispatch, getState) => {
    dispatch(showDetailsStateStart());
    try {
        const response = await getShowDetails(id);
        dispatch(setShowDetailsState({details: response}));
        dispatch(showDetailsStateEnd(Status.SUCCESSFUL));
    }catch(e){
        dispatch(setShowDetailsState({details: null}));
        dispatch(showDetailsStateEnd(Status.ERROR));
    }
}